import React, {FC} from 'react';
import styled from 'styled-components';
import {Key} from 'ts-key-enum';

import {BoxedInput} from '../../../../../../libs/shared/ui/src/components/boxedInputs/boxedInput';
import {
  BoxedInputElement,
  BoxedInputElementTypesEnum,
} from '../../../../../../libs/shared/ui/src/components/boxedInputs/boxedInputElement';
import {BoxedInputIcon} from '../../../../../../libs/shared/ui/src/components/boxedInputs/boxedInputIcon';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {
  InboxesSearchQueryBuilderBaseInputConfig,
  InboxesSearchQueryBuilderInputValue,
} from './inboxesSearchQueryBuilderTypes';

/*
 * Props.
 */

interface InboxesSearchQueryBuilderTextInputProps
  extends InboxesSearchQueryBuilderBaseInputConfig,
    InboxesSearchQueryBuilderInputValue {}

/*
 * Styles.
 */

const StyledBoxInputElement = styled(BoxedInputElement)`
  margin-left: 0px;
`;

/*
 * Component.
 */

export const InboxesSearchQueryBuilderTextInput: FC<InboxesSearchQueryBuilderTextInputProps> = (props) => {
  const theme = useUserTheme();
  const {id, icon, placeholder, inputValue, onChange, onSearch} = props;
  const {value} = inputValue;

  return (
    <BoxedInput size={VisualSizesEnum.MEDIUM} noMargin>
      {(childProps) => (
        <>
          <BoxedInputIcon {...childProps} iconName={icon} color={theme.greys.shade70} />
          <StyledBoxInputElement
            {...childProps}
            type={BoxedInputElementTypesEnum.TEXT}
            placeholder={placeholder}
            value={value}
            onChange={(newValue: string) =>
              onChange({
                ...inputValue,
                value: newValue,
              })
            }
            onKeyDown={(event) => {
              // Call `onSearch` (if defined) when hitting Enter.
              if (onSearch && event.key === Key.Enter) {
                // Avoid calling `onSearchEnter` directly.
                event.stopPropagation();

                onSearch();
              }
            }}
            interactionId={`search-query-builder-${id}`}
          />
        </>
      )}
    </BoxedInput>
  );
};
